import { getEnvVariable } from './getEnvVariable'

// Runtime feature flags read from REACT_APP_* env vars; defaults hide optional features.

const flag = (name: string, defaultValue: boolean): boolean => {
  const raw = getEnvVariable(name, defaultValue ? 'true' : 'false').toLowerCase()
  return raw === 'true' || raw === '1' || raw === 'yes'
}

/** Toggles HTTP Proxy UI visibility. Backend stays protected by SCOPE_PROXY_READ regardless. */
export const SHOW_PROXIES = flag('REACT_APP_SHOW_PROXIES', false)
